import { render, staticRenderFns } from "./HikeGeninfo.vue?vue&type=template&id=35ce8bc1&scoped=true"
import script from "./HikeGeninfo.vue?vue&type=script&lang=js"
export * from "./HikeGeninfo.vue?vue&type=script&lang=js"
import style0 from "./HikeGeninfo.vue?vue&type=style&index=0&id=35ce8bc1&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce8bc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ce8bc1')) {
      api.createRecord('35ce8bc1', component.options)
    } else {
      api.reload('35ce8bc1', component.options)
    }
    module.hot.accept("./HikeGeninfo.vue?vue&type=template&id=35ce8bc1&scoped=true", function () {
      api.rerender('35ce8bc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/hike/components/HikeGeninfo.vue"
export default component.exports